import React, { useState } from "react";
import Button from "../../../forms/Button";
import AddressItem from "../../../single-items/AddressItem";

const AddressAddButton = ({ setAddModalOpen = () => {} }) => {
  return (
    <>
      <Button
        buttonClasses={
          "aspect-[3/2] 3xl:aspect-[4/3] w-full !h-auto relative overflow-hidden py-4 px-4 border-2 border-dashed border-md-pink-light-1 bg-white rounded-lg hover:shadow-md hover:shadow-md-pink/20 transition-all duration-300 !bg-md-pink-light-2 z-0 flex-col items-center justify-center gap-0"
        }
        // buttonFunction={() => setAddModalOpen(true)}
        buttonFunction={() => setAddModalOpen(null)}
        buttonLabel={
          <div className="">
            <div className="text-4xl 2xl:text-5xl text-md-pink">
              <i className="fa-regular fa-plus"></i>
            </div>
            <div className="text-sm 2xl:text-lg text-md-dark">Add Address</div>
          </div>
        }
      />
    </>
  );
};

const AddressList = ({
  title,
  data,
  setAddresses = () => {},
  setAddModalOpen = () => {},
  setDeleteModal = () => {},
  onSetDefault,
}) => {
  console.log("Rendering AddressList", data);
  const handleSetDefault = (id) => {
    setAddresses((prev) =>
      prev.map((item) => ({
        ...item,
        isDefault: item._id === id,
      }))
    );
  };

  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            {title}
          </div>
          <div className="ml-auto flex items-center gap-x-4 flex-shrink-0">
            <Button
              buttonHasLink={false}
              buttonIcon={"fa-regular fa-fw fa-plus"}
              buttonIconPosition={"left"}
              buttonLabel={"Add Address"}
              buttonClasses={
                "!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"
              }
              buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"}
              // buttonFunction={() => setAddModalOpen(true)}
              buttonFunction={() => setAddModalOpen(null)}
            />
          </div>
        </div>
        <div className="relative">
          {data?.length > 0 && (
            <div className="grid grid-cols-2 3xl:grid-cols-3 gap-4">
              {data?.map((item, index) => (
                <AddressItem
                  // key={index}
                  key={item._id}
                  data={item}
                  // onSetDefault={handleSetDefault}
                  // setAddModalOpen={setAddModalOpen}
                  setAddModalOpen={() => setAddModalOpen(item)}
                  setDeleteModal={setDeleteModal}
                  onSetDefault={onSetDefault}
                />
              ))}
              <AddressAddButton setAddModalOpen={() => setAddModalOpen(null)} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddressList;
